
let BASE_URL;
let ASSETS_URL;

if (process.env.NODE_ENV === 'development') {
  BASE_URL = 'http://127.0.0.1:8080/api';
  ASSETS_URL =`http://127.0.0.1:8080/storage/uploads/`;
} else {
  BASE_URL = 'https://test.branded-sms.pk/api'; 
  ASSETS_URL =`http://127.0.0.1:8080/storage/uploads/`;
}

export {BASE_URL, ASSETS_URL};
